<template>
  <router-view></router-view>
</template>

<script>
  import AppSettingsMixin from '@/mixins/AppSettingsMixin'
  import ModalHandlerMixin from '@/mixins/ModalHandlerMixin'
  import ModalProtectionMixin from '@/mixins/ModalProtectionMixin'

  export default {
    name: 'app',
    mixins: [AppSettingsMixin, ModalHandlerMixin, ModalProtectionMixin], 
  }
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';

  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import 'assets/scss/simple-line-icons.scss';
  //@import '~simple-line-icons/scss/simple-line-icons.scss';

  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';

  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';

  // Import Main styles for this application
  @import 'assets/scss/style';

  //  Import style for this notifications
  @import '~vue-awesome-notifications/dist/styles/style.scss';
  @import 'assets/scss/toast';

  // Import style for this loading
  @import '~vue-loading-overlay/dist/vue-loading.css';

  //  Import style for this calendar
  @import '~@fullcalendar/core/main.css';
  @import '~@fullcalendar/daygrid/main.css';
  // Reskin con los tokens del sistema de diseño -- tiene que ir DESPUÉS de
  // las dos importaciones de arriba (misma especificidad, gana el que carga
  // último) para pisar el tema "unthemed" de fábrica.
  @import 'assets/scss/calendar-interfaces';

  //  Import style for this select
  @import 'assets/css/vue-select.css';

  @import 'assets/css/kanban.css';
</style>
